var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustline = function SvgTrustline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007DC5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.382h5.168v5.381H0zM10.067 9.06v4.772H5.791V3.48h4.276zM10.69 3.481h5.211v4.956H10.69zM10.69 8.947h5.211v4.885H10.69z"
  }))));
};
export { SvgTrustline as ReactComponent };
export default __webpack_public_path__ + "d88bb2334141a9addb6a732c9d2434df.svg";